import { DependencyLifeTime, Injectable } from "@miracledevs/paradigm-web-di";
import { ReactElement } from "react";
import { ContextCollection } from "../../contexts/DependencyContext";
import { IWidget } from "../http/widget/models/IWidget";
import { WidgetTypes } from "../http/widget/models/WidgetTypes";

export interface IButtonProperties
{
    url: string;
    text: string;
}

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class BaseWidgetService
{

    fullscreenWidgets = {
        summary: "summary",
        indicatorLogs: "indicator-logs",
        indicatorList: "indicator-list",
        indicatorStatusHistory: "indicator-status-history",
        sensorChart: "sensor-chart"
    };

    getWidgetBody(widget: IWidget | undefined, widgetTtype: string, currentFilters?: Object | null, widgets?: IWidget[]): ReactElement | null
    {
        return null;
    }

    getWidgetConfig(widget: IWidget): any
    {
        return;
    }

    getBadgeText(widgetTypeId: number): string
    {
        switch (widgetTypeId)
        {
            case WidgetTypes.SensorChart:
            case WidgetTypes.MachineLearningPrediction:
                return 'Last 24 hours';

            default:
                return 'Last 30 days';
        }
    }

    getButtonProperties(widget: IWidget, componentId: number): IButtonProperties
    {
        let text: string = '+ more';
        let url: string = '';

        const { widgetType, id } = widget;

        switch (widgetType)
        {
            case WidgetTypes.CurrentIssues:
                text = 'all';
                url = `/dashboard/${componentId}/${this.fullscreenWidgets.indicatorList}/${id}`;
                break;

            case WidgetTypes.SensorChart:
                const navigation = {
                    text: "+ more",
                    url: `/dashboard/${componentId}/${this.fullscreenWidgets.sensorChart}/${id}`
                };

                if (widget.uiConfiguration)
                {
                    const uiConfig = JSON.parse(widget.uiConfiguration);
                    if (uiConfig.componentId && uiConfig.componentId !== componentId)
                    {
                        navigation.text = "go to";
                        navigation.url = `/dashboard/${uiConfig.componentId}`;
                    }
                };

                text = navigation.text;
                url = navigation.url;
                break;

            case WidgetTypes.SensorIcon:
                text = '+ more'; //isSensorComponent ? more : goto
                //url = `/dashboard/${componentId}/${this.fullscreenWidgets.sensorIcon}/${widget.id}`;
                break;

            case WidgetTypes.StatusHistory:
                text = '+ more';
                url = `/dashboard/${componentId}/${this.fullscreenWidgets.indicatorStatusHistory}/${id}`;
                break;

            case WidgetTypes.Weather:
                const uiConfig = JSON.parse(widget.uiConfiguration);
                if (uiConfig.weatherComponentId)
                {
                    text = 'go to';
                    url = `/dashboard/${uiConfig.weatherComponentId}`;
                }
                break;

            default:
                text = "";
                url = "";
                break;
        }

        return { text, url }
    }

    widgetHasBadge(widgetTypeId: number): boolean
    {
        return widgetTypeId === WidgetTypes.StatusHistory ||
            widgetTypeId === WidgetTypes.SensorChart ||
            widgetTypeId === WidgetTypes.MachineLearningPrediction;
    }

    updateUiConfig(config: string, propertyValue: any, propertyName: string): string
    {
        const uiConfig = JSON.parse(config);
        uiConfig[propertyName] = propertyValue;
        return JSON.stringify(uiConfig);
    }
}